import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useDebouncedCallback } from 'use-debounce';
import { memo, useEffect, useState } from 'react';

const SearchInput = ({
    value: controlledValue,
    placeholder = 'Search...',
    delay = 500,
    onSearch,
    size = 'large',
    className,
    ...rest
}) => {
    const [value, setValue] = useState(controlledValue ?? '');

    useEffect(() => {
        setValue(controlledValue ?? '');
    }, [controlledValue]);

    const debouncedSearch = useDebouncedCallback((val) => {
        onSearch?.(val.trim());
    }, delay);

    const handleChange = (e) => {
        const val = e.target.value;
        setValue(val);
        debouncedSearch(val);
    };
    return (
        <Input
            className={className ?? 'w-full lg:max-w-20rem'}
            size={size}
            placeholder={placeholder}
            prefix={<SearchOutlined />}
            value={value}
            onChange={handleChange}
            allowClear
            {...rest}
        />
    );
};

export default memo(SearchInput);
